/**
 * @Description: 解决方案
 * @author: Xiao'Hong
 * @date: 2021/2/22
 * @fileName: solution
 */
export default [
    {path: "/solution", component: () => import('@/views/solution/solution.vue')},
]
